import { useMemo, useState } from 'react';
import { Text } from '@linearb/linui-common';
import Icon from 'components/base/Icon';
import MovingBox from 'images/moving-box.svg';
import { Padding } from 'components/base/layout-components';
import get from 'lodash/get';
import { CUSTOM_DASHBOARD_INTERNAL_TYPES } from '@linearb/linjs-common';
import {
  BoxWrapper,
  ButtonWrapper,
  CloseIconWrapper,
  ContentWrapper,
  PMWidgetWrapper
} from './PMWidgetsDeprecationNotice.style';
import { LBButton } from '@linearb/buzz';

const DEPRECATED_METRICS = ['pm.issues.done.story_points', 'pm.issues.done'];

const PMWidgetsDeprecationNotice = ({
  graph,
  customDashboards,
  selectReportAndRedirect
}) => {
  const [isClosed, setIsClosed] = useState(false);

  const pmCustomDashboards = useMemo(() => {
    if (!customDashboards?.length) {
      return [];
    }
    return customDashboards.filter(
      ({ internal_type: internalType }) =>
        internalType === CUSTOM_DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS
    );
  }, [customDashboards]);

  const metricName = get(graph, 'metrics[0].name');
  const shouldShowDeprecationNotice = DEPRECATED_METRICS.includes(metricName);

  const onCloseClicked = () => setIsClosed(true);

  const routeToCustomDashboard = () => {
    const autoCreatedCustomPm = pmCustomDashboards.find(
      ({ extended_data: { auto_created: autoCreated } }) => autoCreated
    );

    if (autoCreatedCustomPm) {
      selectReportAndRedirect(autoCreatedCustomPm, autoCreatedCustomPm.id);
    } else {
      selectReportAndRedirect(pmCustomDashboards[0], autoCreatedCustomPm.id);
    }
  };

  if (!shouldShowDeprecationNotice || isClosed || !pmCustomDashboards.length) {
    return <></>;
  }

  return (
    <PMWidgetWrapper flex-direction='column'>
      <BoxWrapper>
        <img src={MovingBox} alt='Moving Box' />
      </BoxWrapper>
      <CloseIconWrapper>
        <Icon
          name='CloseIcon'
          color='shark'
          cursor='pointer'
          onClick={onCloseClicked}
        />
      </CloseIconWrapper>
      <ContentWrapper>
        <Text weight='300' color='shark' size='x-large' align='center'>
          We’re moving and improving!
        </Text>
        <Padding b='small'>
          <Text weight='400' color='shark' size='large' align='center'>
            This widget will now be available in the
            <br /> Custom PM Dashboard.
          </Text>
        </Padding>
        <ButtonWrapper>
          <LBButton size='sm' onClick={routeToCustomDashboard}>
            <Icon name='Wrench' size='smaller' color='white' />
            Customize dashboard
          </LBButton>
        </ButtonWrapper>

        <Text weight='400' color='shark' size='x-medium' align='center'>
          The current widget will be deprecated
          <br /> on Sep 15th, 2023
        </Text>
      </ContentWrapper>
    </PMWidgetWrapper>
  );
};

export default PMWidgetsDeprecationNotice;
